module.exports = __webpack_public_path__ + "img/fr_success_3.b82800eb.png";